import { initReactI18next } from 'react-i18next';

import LanguageDetector from 'i18next-browser-languagedetector';
import de from './de.json';
import en from './en.json';
import es from './es.json';
import fr from './fr.json';
import i18n from 'i18next';

import zh from './zh.json';

export const ORIGIN = window.location.origin.includes('3d4medical.com')
  ? '3d4medical.com'
  : 'completeanatomy.cn';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: en,
      },
      es: {
        translation: es,
      },
      zh: {
        translation: zh,
      },
      fr: {
        translation: fr,
      },
      de: {
        translation: de,
      },
    },
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'navigator'],
      lookupQuerystring: 'lang',
      lookupCookie: 'wp-wpml_current_language',
      cookieDomain: ORIGIN,
      caches: ['cookie'],
    },
  });

export default i18n;
